/*
* faq Vue component
* ---
* Related products retrieved via Product Recommendations Ajax API
* https://shopify.dev/docs/themes/ajax-api/reference/product-recommendations
*
* Example usage:
*
* <faq inline-template/>
*/

import Collapsible from './collapsible.vue';
import Accordion from './accordion.vue';

export default {
    components: {
        Collapsible,
        Accordion
    }
}